import {
  SAVE_VENDOR_INFO,
} from '../constants/actionTypes';

// TODO Essa etapa é uma POC e deve ser refatorada no futuro
const INITIAL_STATE = {
  payload: null,
};

const saveVendorInfo = (state, action) => ({
  ...state,
  vendedorInfo: action.payload,
});

const vendorReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SAVE_VENDOR_INFO:
      return saveVendorInfo(state, action);
    default:
      return state;
  }
};

export default vendorReducer;
